import React from 'react';
import { connect } from 'react-redux';
import {
    toggleShowAddOrgUnitStaff,
    fetchOrgUnitPositions,
    fetchOrgUnitEmployees,
    selectOrgUnitStaffPosition,
    selectOrgUnitStaffEmployee,
    addOrgUnitStaff
} from './../../../reduxFiles/actionTypes';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import staffIcon from './../network.svg';
import { Item, Button, Label, Icon, Segment, Dropdown } from 'semantic-ui-react';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class OrgUnitStaff extends React.Component {

    constructor(props) {
        super(props);
        this.showAddOrgUnitStaff = this.showAddOrgUnitStaff.bind(this);
        this.addStaff = this.addStaff.bind(this);

        if (this.props.isAddingStaff) {
            this.props.dispatch(toggleShowAddOrgUnitStaff());
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.orgUnitId !== nextProps.orgUnitId && this.props.isAddingStaff) {
            this.props.dispatch(toggleShowAddOrgUnitStaff());
        }
    }

    showAddOrgUnitStaff() {
        this.props.dispatch(fetchOrgUnitPositions(this.props.orgUnitId));
        this.props.dispatch(fetchOrgUnitEmployees());
        this.props.dispatch(toggleShowAddOrgUnitStaff());
    }

    addStaff() {
        const position = this.props.positions.items.find(el => (el.id === this.props.orgUnitPositionIdToAdd));
        this.props.dispatch(addOrgUnitStaff(this.props.orgUnitId, this.props.orgUnitEmployeeIdToAdd, position));
    }

    render() {
        const {staff, isAddingStaff, positions, employees, orgUnitPositionIdToAdd, orgUnitEmployeeIdToAdd, addingStaffError} = this.props;

        if (isAddingStaff && positions.error) {
            toast(<FormattedMessage id='orgUnitDetailed.errors.gettingPositions'/>);
        }
        if (isAddingStaff && employees.error) {
            toast(<FormattedMessage id='orgUnitDetailed.errors.gettingEmployees'/>);
        }
        if (addingStaffError) {
            toast(<FormattedMessage id='orgUnitDetailed.errors.addingStaff'/>);
        }

        return (
            <Item>
                <Item.Image src={staffIcon} size='tiny'/>
                <Item.Content style={{paddingRight: '21px'}}>
                    <Item.Header><AddOrgUnitStaff showAddOrgUnitStaff={this.showAddOrgUnitStaff} hasType={this.props.hasType}/></Item.Header>
                    <Item.Description>
                        {isAddingStaff && positions.items && employees.items &&
                            <Segment raised>
                                <label><FormattedMessage id='orgUnitDetailed.staffPosition'/></label>
                                <Dropdown clearable
                                    onChange={(e, {value}) => this.props.dispatch(selectOrgUnitStaffPosition(value))}
                                    fluid
                                    search
                                    selection
                                    style={{marginBottom: '5px'}}
                                    value={orgUnitPositionIdToAdd}
                                    options={positions.items.map(position =>
                                        ({ key: position.id, value: position.id, text: position.name })
                                    )}/>
                                <label><FormattedMessage id='orgUnitDetailed.staff'/></label>
                                <Dropdown clearable
                                    onChange={(e, {value}) => this.props.dispatch(selectOrgUnitStaffEmployee(value))}
                                    fluid
                                    search
                                    selection
                                    style={{marginBottom: '5px'}}
                                    value={orgUnitEmployeeIdToAdd}
                                    options={employees.items.map(employee =>
                                        ({ key: employee.id, value: employee.id, text: employee.firstName + ' ' + employee.lastName })
                                    )}/>
                                <Icon circular name='check' onClick={this.addStaff}/>
                                <Icon circular name='cancel' onClick={() => {this.props.dispatch(toggleShowAddOrgUnitStaff());}}/>
                            </Segment>
                        }
                        <div className="ui bulleted list">
                            {staff.map((staff, index) =>
                                <div className="item" key={index}>{staff.firstName} {staff.lastName}, {staff.academicTitle}, {staff.position}</div>
                            )}
                        </div>
                    </Item.Description>
                </Item.Content>
            </Item>
        )
    }
}

const AddOrgUnitStaff = props => (
    <Button as='div' labelPosition='left' onClick={(event, data) => {props.hasType ? props.showAddOrgUnitStaff() : toast(<FormattedMessage id='orgUnitDetailed.errors.mustHaveType'/>); }}>
        <Label as='a' basic pointing='right'><FormattedMessage id='orgUnitDetailed.staff'/></Label>
        <Button icon>
            <Icon name='plus' />
        </Button>
    </Button>
)

function mapStateToProps(state) {
    return {
        isAddingStaff: state.ui.orgUnitsView.staffView.isAddingStaff,
        orgUnitPositionIdToAdd: state.ui.orgUnitsView.staffView.orgUnitPositionIdToAdd,
        orgUnitEmployeeIdToAdd: state.ui.orgUnitsView.staffView.orgUnitEmployeeIdToAdd,
        positions: state.ui.orgUnitsView.staffView.positions,
        employees: state.ui.orgUnitsView.staffView.employees,
        isSendingStaff: state.ui.orgUnitsView.staffView.isSendingStaff,
        addingStaffError: state.ui.orgUnitsView.staffView.addingStaffError
    }
}

export default connect(mapStateToProps)(OrgUnitStaff);



// WEBPACK FOOTER //
// ./src/views/OrganizationalUnit/components/OrgUnitStaff.js